/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ChairCount/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Action from './Action/index'
import Popover from 'DesignSystem/Popover/index'
import PopoverContentHover from 'DesignSystem/Popover/PopoverContentHover/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import Tooltip from 'DesignSystem/Tooltip/index'



/** @type {import('Simple/types.js').View} */
export default function ChairCount({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/Calendar/Content/Content/Topbar/LowerSection/ChairCount"
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<Popover
  viewPath={`${viewPath}/Popover`}
 showOnHover={true}
 showOnClick={false}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<Action
{...childProps}
  viewPath={`${viewPath}/Action`}
/>
)}
</PopoverTrigger>
<PopoverContentHover
{...childProps}
  viewPath={`${viewPath}/PopoverContentHover`}
>
{childProps => (
<Tooltip
{...childProps}
  viewPath={`${viewPath}/Tooltip`}
 backgroundColor={dtColorsWhite}
 color={dtColorsNeutral500}
 maxWidth={240}
 height="auto"
 className="new-shadow"
 whiteSpace="normal"
 text="Configure how many chairs you want to see in your daily schedule"
 className="new-shadow"
/>
)}
</PopoverContentHover>
</React.Fragment>
)}
</Popover>
{children}
</React.Fragment>)
}